import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';
import TPs from './tp';

const editorRenderer = (getControl, {
  dataSetter, fields, currentUser, data,
}) => {
  console.log(currentUser);
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        {getControl('name')}
      </Grid>
      {currentUser.is_superuser && (
        <Grid item sm={12}>
          {getControl('org', { backend: '/api/catalog/orgs/' })}
        </Grid>
      )}
      <Grid item sm={12}>
        <TPs.GeneralTP
          data={data.zoneratehistory_set}
          options={fields.zoneratehistory_set}
          onChange={(e, newRecs) => dataSetter({ zoneratehistory_set: newRecs })}
        />
      </Grid>
    </Grid>
  );
};

export default getBaseEditor(editorRenderer, '/api/catalog/zones/', CommandPanels.catCommandPanel);
